// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Currency from "../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as CountryConfig from "../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TableComponent$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";

function SlabsTable(Props) {
  var slabs = Props.slabs;
  var match = CountryContext.useContext(undefined);
  var currency = CountryConfig.getSymbol(match.country);
  var tableSchema_0 = {
    column: {
      TAG: /* Text */0,
      _0: "SLAB"
    },
    accessor: (function (slab) {
        if (slab.is_last) {
          return {
                  TAG: /* Custom */5,
                  _0: (function (param) {
                      return React.createElement("b", undefined, slab.slab_no);
                    })
                };
        } else {
          return {
                  TAG: /* Text */0,
                  _0: slab.slab_no
                };
        }
      })
  };
  var tableSchema_1 = {
    hd: {
      column: {
        TAG: /* Text */0,
        _0: "SLAB KM RANGE"
      },
      accessor: (function (slab) {
          if (slab.is_last) {
            return {
                    TAG: /* Custom */5,
                    _0: (function (param) {
                        return React.createElement("b", undefined, slab.slab_range);
                      })
                  };
          } else {
            return {
                    TAG: /* Text */0,
                    _0: slab.slab_range
                  };
          }
        })
    },
    tl: {
      hd: {
        column: {
          TAG: /* Text */0,
          _0: "PRICE PER KM"
        },
        accessor: (function (slab) {
            if (slab.is_last) {
              return {
                      TAG: /* Custom */5,
                      _0: (function (param) {
                          return React.createElement("b", undefined, Currency.toCurrencyString(slab.price_per_km, currency));
                        })
                    };
            } else {
              return {
                      TAG: /* Text */0,
                      _0: Currency.toCurrencyString(slab.price_per_km, currency)
                    };
            }
          })
      },
      tl: {
        hd: {
          column: {
            TAG: /* Text */0,
            _0: "PRICE PER MIN"
          },
          accessor: (function (slab) {
              if (slab.is_last) {
                return {
                        TAG: /* Custom */5,
                        _0: (function (param) {
                            return React.createElement("b", undefined, Currency.toCurrencyString(slab.price_per_min, currency));
                          })
                      };
              } else {
                return {
                        TAG: /* Text */0,
                        _0: Currency.toCurrencyString(slab.price_per_min, currency)
                      };
              }
            })
        },
        tl: /* [] */0
      }
    }
  };
  var tableSchema = {
    hd: tableSchema_0,
    tl: tableSchema_1
  };
  return React.createElement(CardComponent$Catalyst.make, {
              className: "campaign-primary-info-card",
              children: React.createElement(TableComponent$Catalyst.make, {
                    columns: tableSchema,
                    rowData: slabs,
                    className: "campaign-slab-table"
                  })
            });
}

var make = SlabsTable;

export {
  make ,
  
}
/* react Not a pure module */
